"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Delivery_API_PATH = exports.DeliveryPath = void 0;
exports.DeliveryPath = {
    delivery: "/delivery"
};
exports.Delivery_API_PATH = {
    getAll: {
        frontend: "api/delivery/all",
        backend: "/all"
    },
    getById: {
        frontend: (id) => "api/delivery/" + id,
        backend: "/:id"
    },
    getByClientId: {
        frontend: (clientId) => "api/delivery/client/" + clientId,
        backend: "/client/:clientId"
    },
    getByOrderNumber: {
        frontend: (orderNumber) => "api/delivery/ordernumber/" + orderNumber,
        backend: "/ordernumber/:orderNumber"
    },
    getByOrderId: {
        frontend: "api/delivery/order/:orderId",
        backend: "/order/:orderId"
    },
    create: {
        frontend: "api/delivery/new",
        backend: "/new"
    },
    update: {
        frontend: "api/delivery/update/:id",
        backend: "/update/:id"
    },
    updateStatus: {
        frontend: "api/delivery/status/:id",
        backend: "/status/:id"
    },
    assign: {
        frontend: "api/delivery/assign/:id",
        backend: "/assign/:id"
    }
};
//# sourceMappingURL=delivery.js.map